module.exports = __webpack_public_path__ + "static/regulatormiddle-e41032c7f62030725d854089437b4114.jpg";